export const DEMO_POST_REQUESTS_LIST = [
  'ip',
  'warmup',
  'googlepagespeed',
  'actions',
  'check-domain',
  'get-optimize-status',
  'rerun-benchmark',
  'user_info',
  'get-pages',
  'get-dns-record',
  'settings',
  'cache/exclude',
  'instance-info',
  'domain-name',
  'certificate',
  'redirect-rules',
  'logs',
  'backups',
  'storage',
  'visitors',
  'domains/storage',
  'domains/visitors',
  'builder/get-pages',
  'widgets/ordering',
  'plugins',
  'addons',
  'themes',
  'optimization_data',
  'connection/troubleshoot',
  'stat',
  'get',
  'templates/last',
  'products-update/plugin/history',
  'products-update/plugin',
  'products-update/theme/history',
  'products-update/theme',
  'two-settings'
];
